// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ZPOSq","page":"Loader_page__Eqw-S","l20-1":"Loader_l20-1__jcNHZ","l20-2":"Loader_l20-2__LV3st"};